export default {
    order: 50,
    apply: (permissionsMap = {}, grantedPermissions = [], context = {}) => {
        const out = { ...permissionsMap };

        out.menu = {};
        
        // show admin menu if any of these read permissions are granted
        // Else just show the Profile menu item at top level
        if(out.ravens?.read ||
            out.tags?.read ||
            out.users?.read ||
            out.assets?.read
        ) {
            out.menu.admin = true;
        }
        
        return out;
    }
}